import { Component, OnInit, Inject, Input } from '@angular/core';
import { ListUnididadeFederacao } from '../../../../shared/model/uf/ufs.model';
import { FormBuilder, FormGroup, FormArray, FormControl } from '@angular/forms';
import { Customer } from '../../../../shared/model/customer/customer.model';
import { fuseAnimations } from '@fuse/animations';
import { MAT_DIALOG_DATA, MatDialog, MatSnackBar } from '@angular/material';
import { CaptacaoService } from '../../../../customers/components/captacao/services/captacao.service';
import { DeleteConfirmationComponent } from '../../../dialogs/delete-confirmation/delete-confirmation.component';
import { Estado } from 'app/main/shared/model/estado/estado.model';

@Component({
  selector: 'app-captacao-forms-endereco',
  templateUrl: './captacao-forms-endereco.component.html',
  styleUrls: ['./captacao-forms-endereco.component.scss'],
  animations: [fuseAnimations]
})
export class CaptacaoFormsEnderecoComponent implements OnInit {

  @Input() customerId;
  @Input() customer: FormGroup;

  step = 0;
  totalCustomer: number;
  address;
  addressComercial: FormGroup;
  showPanelId: Boolean;
  currentCustomer: Customer;

  constructor(
    private formBuilder: FormBuilder,
    private captacaoService: CaptacaoService,
    @Inject(MAT_DIALOG_DATA) public _data: any,
    private _matDialog: MatDialog,
    public snackBar: MatSnackBar) {
    }

  ngOnInit(): void {    
    // tslint:disable-next-line:triple-equals
    if (this.customer.value.listEndereco.length == 0) {
      this.add();
    }
  }

  get addressForms(): FormArray {
    return this.customer.get('listEndereco') as FormArray;
  }

  add(required?: boolean): void {
    const address = this.formBuilder.group({
      id: [],
      cep: new FormControl(null),
      logradouro: new FormControl(null),
      numero: new FormControl(null),
      latitude: new FormControl(null),
      longitude: new FormControl(null),
      bairro: new FormControl(null),
      complemento: new FormControl(null),
      pontoReferencia: new FormControl(null),
      municipio: new FormControl(null),
      estado: new FormControl(null),
      tipoEndereco: new FormControl(null)
    });
    this.addressForms.push(address);
  }

  delete(index: number): void {
    this.addressForms.removeAt(index);

  }


  setStep(index: number): void {
    this.step = index;
  }

  nextStep(): void {
    this.step++;
  }

  private openConfirmModal(index: number): void {
    this._matDialog.open(DeleteConfirmationComponent, {
      panelClass: 'captacao-form-dialog',
      hasBackdrop: false
    }).afterClosed().subscribe(data => {
      if (data) {
        const msg = 'Endereço Excluido Com Sucesso!';
        this.feedbackSnack(msg);
        this.addressForms.removeAt(index);
      } else {
        const msg = 'Erro ao Excluir Endereço!';
        this.feedbackSnack(msg);
      }
    });
  }

  prevStep(): void {
    this.step--;
  }

  getErrorMessage(field: string): string {
    return `O campo ${field} é obrigatório`;
  }

  private feedbackSnack(message: string): void {
    this.snackBar.open(message, '', {
      verticalPosition: 'bottom',
      duration: 2700,
    });
  }
}
